// Booking dates are picked using each device's local timezone. Storing the raw
// Date object means the calendar day can shift by one when read back on a
// device in a different timezone (e.g. a customer booking from a timezone
// ahead of the UK can have their selected day appear as the day before once
// viewed in the admin panel). Normalizing to a fixed UTC instant for the same
// calendar day removes that dependency on either device's timezone.
export const toUtcDateOnly = (date) => {
    const d = new Date(date);
    const normalized = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    console.log(`[toUtcDateOnly] input: ${d.toString()} -> normalized: ${normalized.toISOString()}`);
    return normalized;
};
